module.exports = __webpack_public_path__ + "static/media/31.e1d3f49c.mp3";